import { render, staticRenderFns } from "./DxTerritorialUnit.vue?vue&type=template&id=6e55df78&"
import script from "./DxTerritorialUnit.vue?vue&type=script&lang=js&"
export * from "./DxTerritorialUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports